/**
 * Checks if the user is logged in by checking the presence of a specific cookie.
 * @returns {boolean} True if the user is logged in, false otherwise.
 */
export const isUserLoggedIn = (): boolean => {
  return !!window.crm_user;
};

/**
 * Redirects the user to a third-party login page.
 * The user will be redirected back to the current page after successful login.
 */
export const redirectToCrmLogin = () => {
  const baseUrl = window.crmUrl || process.env.REACT_APP_CRM_BASE_URI;
  const currentLocation = window.location.href;
  const loginBaseUrl = '/sign/processLogin?back=';
  const hash = document.getElementById('remp_lock_anchor') ? '#remp_lock_anchor' : '';
  const encodedCurrentLocation = encodeURIComponent(currentLocation + hash);

  window.location.href = `${baseUrl}${loginBaseUrl}${encodedCurrentLocation}${hash}`;
};

/**
 * Opens the login modal and adds necessary event listeners to handle closing the modal.
 */

export type LoginModalOpenSource = 'bookmark' | 'follow-author' | 'follow-topic' | 'newsletter' | undefined;

export const openLoginModal = (source?: LoginModalOpenSource) => {
  if (source) {
    window.openReactLoginModal(source);
  } else {
    window.openReactLoginModal();
  }
};
